{
  "app-frame": {
    "buttons": {
      "be-partner": "Pour les propriétaires de salons",
      "login": "Connexion",
      "logout": "Déconnexion",
      "my-appointments": "Mes rendez-vous",
      "my-salons": "Mes salons",
      "profile": "Profil",
      "read": "Lire",
      "sign-up": "S'inscrire",
      "top-salons": "Meilleurs salons"
    },
    "text": {
      "agb-short": "Les CGV",
      "agb-updated-valid-since": "ont été mises à jour et seront valables à partir de {{date}}",
      "click-to-read": "Cliquez pour lire"
    }
  }
}
